export const processGraphCellValue = (topicValue, unitValue, totalValue) => {
  if (!topicValue || !unitValue) return "default";

  const singleCellValue = (topicValue * unitValue) / totalValue;
  if (singleCellValue < 0.02) return "tepid";
  if (singleCellValue < 0.05) return "warm";
  return "hot";
};
